const getters = {

  // # server ###################
  getServerAdress: state => state.serverAddress,
  // #################### server #

  // PAYMENT #######################
  getBoosts: state => state.boosts,

  getSubscriptions: state => state.subscriptions,

  getOrders: state => state.orders,
  getPromotions: state => state.promotions,
  getPaymentInformation: state => state.paymentInformation,
  getPackageByID: state => packageID => state.packages.find(p => p.id === Number(packageID)) || {},


  getStripeSubscriptions: state => state.stripeSubscriptions,
  getStripeSubscriptionByStripeID: state => (subscriptionID) => {
    const subs = state.stripeSubscriptions;
    return subs.find(s => s.stripeID === subscriptionID);
  },
  getStripeSubscriptionItems: state => state.stripeSubscriptionItems,
  getStripeSubscriptionItemsByStripeID: state => (subscriptionID) => {
    const items = state.stripeSubscriptionItems;
    return items.filter(i => i.subscription === subscriptionID);
  },

  getStripeCustomer: state => state.stripeCustomer,
  getStripePlans: state => state.stripePlans,
  getStripePlanByStripeID: state => (planID) => {
    const plans = state.stripePlans;
    return plans.find(p => p.stripeID === planID);
  },

  getStripeSubscriptionsHistory: state => state.stripeSubscriptionsHistory,
  getStripeInvoicesHistory: state => state.stripeInvoicesHistory,

  getPackageByProductID: state => (productID) => {
    const { boosts } = state;
    const { subscriptions } = state;
    const packages = [...boosts, ...subscriptions];
    return packages.find((p) => {
      if (p && p.product && p.product.stripeID && p.product.stripeID === productID) {
        return true;
      } return false;
    });
  },

  getFreemium: state => state.freemium,
  getFreemiumDaysLeft: (state) => {
    try {
      return state.freemium.activeDays;
    } catch (err) {
      return null;
    }
  },
  getFreemiumActive: (state) => {
    try {
      return (state.freemium.isActive === true);
    } catch (err) {
      return false;
    }
  },
  getFreemiumPackage: (state) => {
    try {
      return state.freemium.package;
    } catch (err) {
      return null;
    }
  },

  getCompanySpecialLimit: (state, getters) => {
    const limit = getters.getPartnerActiveDealLimit;
    return limit ?? Number.MAX_SAFE_INTEGER;
  },

  getPartnerActiveDealLimit: (state, getters, rootState, rootGetters) => {
    const settings = rootGetters['partner/getStatus']?.activeDealLimit;
    if (!settings?.enabled) return null;
    const limit = Number(settings.limit);
    return Number.isFinite(limit) && limit >= 1 ? limit : 10;
  },

  getPartnerActiveDealCount: (state, getters, rootState, rootGetters) => (
    (rootGetters['specials/getSpecials'] || [])
      .filter((special) => Number(special.itemStatus) === 0
        && !special.isBonusExclusive
        && !special.isThankYouExclusive
        && !special.isBirthdayExclusive
        && !special.isFriendsExclusive).length
  ),

  canActivateMorePartnerDeals: (state, getters) => {
    const limit = getters.getPartnerActiveDealLimit;
    if (limit == null) return true;
    return getters.getPartnerActiveDealCount < limit;
  },


  // ################### Payment
};

export default getters;
